const view = /*html*/`

    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl">
        <div class="row g-5 mb-6">
        
            <div class="col-xl-3">
                <!--<div class="row g-lg-5 g-xl-10">
                    <div class="col-md-12 col-xl-12 mb-5 mb-xl-10">-->
                        <div class="card overflow-hidden card-stretch-50 mb-5">
                            <div class="card-body d-flex align-items-center justify-content-center bgi-no-repeat bgi-size-cover bgi-position-x-center" style="background-image: url(assets/media/misc/ts.png);">
                                <div class="fs-6 fw-bold text-gray-800 text-center">
                                    <span class="">Get in touch with more players joining to our
                                        <span class="position-relative d-inline-block text-info">
                                            <a href="ts3server://ts.pdxplay.org" class="text-info fw-bolder opacity-75-hover external-handler">TeamSpeak3</a>                                                          
                                        </span>                     
                                    </span>Server
                                </div>
                            </div>
                        </div>
                        <div class="card overflow-hidden card-stretch-50 mb-5">
                            <div class="card-body d-flex align-items-center justify-content-center bgi-no-repeat bgi-size-cover bgi-position-x-center" style="background-image: url(assets/media/misc/discord.png);">
                                <div class="fs-6 fw-bold text-gray-300 text-center">
                                    <span class="">Get support and help from our
                                        <span class="position-relative d-inline-block text-info">
                                            <a href="https://discord.gg/9u4mHsf3dD" target="_blank" class="text-info fw-bolder opacity-75-hover external-handler">Discord</a>                                                          
                                        </span>                     
                                    </span>Server
                                </div>
                            </div>
                        </div>
                    <!--</div>            
                </div>-->
            </div>
        
            <div class="col-xl-6">
                <div class="card card-flush card-stretch overflow-hidden mw-650px align-self-center ms-auto me-auto">
                    <div class="card-body p-0 m-0 widget-news-carousel">
                    </div>
                </div>
            </div>
        

        
            <div class="col-xl-3">
            

                <div class="card bg-transparent shadow-none card-flush card-stretch">
                    
                    <div class="card-header border-0 bg-gray-100 min-h-50px rounded">
                        
                        <h4 class="card-title m-0">
                            <span class="text-dark fs-3 teko-header pt-1">Quick Actions</span>
                        </h4>
                        
                    </div>
        

        
                    <div class="card-body">                        
                        <div class="d-grid gap-3">
                            <button class="btn btn-flex btn-light-primary border-hover-primary btn-active-primary btn-active-color-gray-100 solo-btn-start shadow-sm teko-semibold" disabled>
                                <i class="fad fa-play fs-4 me-1"></i><span class="text-uppercase fs-4" data-i18n="">Play SOLO Ranked 5v5</span>
                            </button>
                            
                            <button data-navigo href="play/pug" class="btn btn-flex btn-light-success border-hover-success btn-active-success btn-active-color-gray-100 shadow-sm teko-semibold">
                                <i class="fad fa-swords fs-4 me-1"></i><span class="text-uppercase fs-4" data-i18n="">Play PUG 5v5</span>
                            </button>
                            
                            <button class="btn btn-flex btn-light-info border-hover-info btn-active-info btn-active-color-gray-100 shadow-sm teko-semibold mm-quick-match" data-type="csdm" data-mode="practice">
                                <i class="fad fa-bolt fs-4 me-1"></i><span class="text-uppercase fs-4" data-i18n="">Quick CSDM</span>
                            </button>

                            <a href="akros://init/" class="btn btn-flex btn-light-danger border-hover-danger btn-active-danger btn-active-color-gray-100 shadow-sm teko-semibold external-handler">
                                <i class="fad fa-shield fs-4 me-1"></i><span class="text-uppercase fs-4" data-i18n="">Run Akros Anticheat</span>
                            </a>
                        </div>
                    </div>    
                </div>
            </div>      
        </div>

        <h3 class="fw-bold text-gray-900">Best Players by Country</h3>
        
        <div class="row row-cols-1 row-cols-xs-2 row-cols-sm-3 row-cols-md-3 row-cols-lg-3 row-cols-xl-5 g-5 widget-best-players">
            
        </div>
    
    </div>`;
           




export default view;